export default __webpack_public_path__ + "static/media/lekan.641fbee5.png";